var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-heading",class:{
    'primary-type': _vm.type == 'primary',
    'white-type': _vm.type == 'white',
  }},[_c('div',{staticClass:"page-heading__body"},[_c('div',{staticClass:"page-heading__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"page-heading__text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }